@if (invoice) {
  <div class="card card-nb h-100 invoice">
    <div class="card-body pb-0">
      <div class="d-flex justify-content-between">
        <div class="p-0 m-0 font-weight-bold">
          <span>{{invoice.name}}&nbsp;</span>
        </div>
        <div>{{invoice.date | localized_date}}</div>
      </div>
      <div class="subinformations">
        <div class="p-0 m-0">
          <div class="d-flex align-items-center align-self-center">
            <i class="fa red fa-cloud"></i>
            <div class="ml-1">[{{invoice.applianceId}}] {{invoice.applianceName}}</div>
          </div>
          <div class="d-flex align-items-center align-self-center">
            <i class="far fa-user red"></i>
            <div class="ml-2">{{invoice.customerName}}</div>
          </div>
        </div>
      </div>
      <div class="subinformations mt-3">
        <div class="d-flex flex-column">
          <div class="d-flex flex-column flex-sm-row justify-content-between">
            <div class="p-0 m-0">
              {{invoice.quantity}} x {{ getProductNameForPreview() }}
            </div>
          </div>
        </div>
      </div>
      @if (invoice.attachments.length > 0) {
        <div class="subinformations mt-3 d-flex justify-content-end">
          <div class="custom-dropdown-menu ml-3" ngbDropdown display="dynamic" placement="bottom-right">
            <div class="btn btn-link d-flex align-items-center p-0 m-0 hide-dropdown-icon" id="dropdownBasic2" ngbDropdownToggle>
              <i class="fas fa-download red icon-size-bigger navbar-profile-icon mr-1"></i>
              <span>{{ 'app_download' | i18next }}</span>
            </div>
            <div ngbDropdownMenu aria-labelledby="dd">
              @for (attachment of invoice.attachments; track attachment) {
                <div>
                  @if (getFormatFromType(attachment.type) !== 'unknown') {
                    <div
                      class="d-flex align-items-center dropdown-item cursor-pointer"
                      (click)="download(attachment.id)"
                      >
                      <i class="fas fa-download features-icon red mr-1"></i>
                      <span>
                        {{ getFormatFromType(attachment.type) | i18next }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
